// Test script to debug Profile component reload issues
export const testProfileReload = () => {
  // Check if component is mounting repeatedly
  let mountCount = 0;
  const originalConsoleLog = console.log;
  
  console.log = (...args) => {
    if (args[0] && args[0].includes && args[0].includes('Profile component mounted')) {
      mountCount++;
      console.warn(`🚨 Profile component mounted ${mountCount} times!`);
    }
    originalConsoleLog.apply(console, args);
  };
  
  // Check localStorage
  const userData = localStorage.getItem('ced:user-info');
  const userStorage = userData ? JSON.parse(userData) : null;
  
  // Check fetching flag
  const isFetching = localStorage.getItem('ced:fetching-user');
  
  // Check Redux state
  const state = window.__REDUX_DEVTOOLS_EXTENSION__ ? 
    window.__REDUX_DEVTOOLS_EXTENSION__.getState() : null;
  
  return {
    mountCount,
    userStorage,
    isFetching,
    state
  };
};

// Clear all flags and data
export const clearAllFlags = () => {
  const keysToRemove = [
    'ced:user-info',
    'ced:fetching-user',
    'ced:userToken',
    'ced:username',
    'ced:role'
  ];
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  
  return true;
};

// Monitor component lifecycle
export const monitorComponentLifecycle = () => {
  const originalConsoleLog = console.log;
  let mountCount = 0;
  let renderCount = 0;
  
  console.log = (...args) => {
    const message = args[0];
    
    if (typeof message === 'string') {
      if (message.includes('Profile component mounted')) {
        mountCount++;
        console.warn(`🚨 MOUNT #${mountCount}: Profile component mounted`);
      }
      
      if (message.includes('render called')) {
        renderCount++;
        console.warn(`🔄 RENDER #${renderCount}: Profile component rendered`);
      }
    }
    
    originalConsoleLog.apply(console, args);
  };
  
  return {
    getMountCount: () => mountCount,
    getRenderCount: () => renderCount,
    reset: () => {
      mountCount = 0;
      renderCount = 0;
    }
  };
};

